export { default } from './Parallax'
